<aw-file-drop (onFilesDropped)="filesDropped($event)">
  <ng-container title>{{ fileDropTranslations.dropFiles }}</ng-container>
  <span subtitle [innerHTML]="subtitle()"></span>
</aw-file-drop>
